// Calendly popup opener — the widget is loaded only when a visitor clicks a booking button.
const CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL;
const WIDGET_BASE = "https://assets.calendly.com/assets/external/widget";
let loading = null;

function loadWidget() {
  if (window.Calendly) return Promise.resolve();
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const css = document.createElement("link");
    css.rel = "stylesheet";
    css.href = `${WIDGET_BASE}.css`;
    document.head.appendChild(css);
    const js = document.createElement("script");
    js.src = `${WIDGET_BASE}.js`;
    js.async = true;
    js.onload = () => resolve();
    js.onerror = () => { loading = null; reject(new Error("Calendly load failed")); };
    document.head.appendChild(js);
  });
  return loading;
}

export function openCalendly() {
  if (!CALENDLY_URL) {
    console.warn("REACT_APP_CALENDLY_URL is not set");
    return;
  }
  loadWidget()
    .then(() => window.Calendly.initPopupWidget({ url: CALENDLY_URL }))
    .catch(() => window.open(CALENDLY_URL, "_blank", "noopener,noreferrer"));
}

export { CALENDLY_URL };
